import { render, staticRenderFns } from "./AppFormWidget.vue?vue&type=template&id=24f03234&scoped=true&"
import script from "./AppFormWidget.vue?vue&type=script&lang=js&"
export * from "./AppFormWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f03234",
  null
  
)

export default component.exports